export default [
  //COUNCIL PROFILE
  {
    path: '/op',
    name: 'op',
    component: () => import('@/views/op/Index.vue'),
    meta: {
      resource: 'Op',
      action: 'read',
      pageTitle: 'OPN Management',
      breadcrumb: [
        {
          text: 'OPN Management',
          active: true
        }
      ],
    },
  },
  {
    path: '/op/:id',
    name: 'opView',
    component: () => import('@/views/op/View.vue'),
    meta: {
      showInMenu: false,
      resource: 'Op',
      action: 'read',
      pageTitle: 'OPN Management',
      breadcrumb: [
        {
          text: 'OPN Management',
          active: true
        }
      ],
    },
  }
]
